/**
 * Black Tulip v3 — the footer's disclosures.
 *
 * Yash, 15 September: "there is no responsive change on mobile. The mobile
 * footer becomes too long and requires excessive scrolling." Twelve link rows
 * at the 44px this theme holds to below 1024 is 528px of footer that never
 * closes, against a live footer that collapses to headings at 749px.
 *
 * The markup ships OPEN and this closes it below the breakpoint. That way
 * round on purpose: with JavaScript off, or in the moment before this runs, the
 * footer is exactly what it is today — long — rather than a row of headings
 * that will not open. A disclosure that needs a script to OPEN is a trap; one
 * that needs a script to CLOSE is an improvement that can fail safely.
 *
 * 768 is v3's own breakpoint — .v3-ft__cols and .v3-ft__list--long both change
 * there — rather than live's 749, so the footer has one place where it changes
 * shape instead of two.
 *
 * A shopper who opens a section and then rotates the phone keeps it open: her
 * choice outranks the breakpoint, and reflowing a panel out from under a
 * finger is worse than a slightly long footer.
 */
(function () {
  'use strict';

  var WIDE = '(min-width: 768px)';

  function boot() {
    var secs = document.querySelectorAll('.v3-ft__sec');
    if (!secs.length) return;

    var mq = window.matchMedia(WIDE);
    var touched = false;

    for (var i = 0; i < secs.length; i++) {
      // Once she has used one, this stops managing any of them.
      secs[i].addEventListener('toggle', function () { touched = true; });
    }

    function apply() {
      if (touched) return;
      var wide = mq.matches;
      for (var j = 0; j < secs.length; j++) {
        // Above the breakpoint the summary is display:none, so an open
        // attribute is the only thing that keeps the list visible there.
        secs[j].open = wide;
      }
    }

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);   // Safari < 14
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
